import { HttpErrorIgnore, HttpErrorUpsert, HttpUpsert200 } from '../../../../global';
import apiSvc, { BinaryFileType } from '../../../core/services/apiSvc';
import validSvc from '../../../core/validSvc';

// read
export const GET_LIST = 'admin/entitygroup/list';
const GET_DETAIL = 'admin/entitygroup/get';
const GET_EXCEL = 'admin/entitygroup/excel';

// write
const CREATE_GROUPS = 'admin/entitygroup/create';
const UPDATE_GROUP = 'admin/entitygroup/update';
const UPDATE_GROUP_STATUS_ACTIVE = 'admin/entitygroup/status/active';
const UPDATE_GROUP_STATUS_INACTIVE = 'admin/entitygroup/status/inactive';
const MEMBER_ADD = 'admin/entitygroup/member/add';
const MEMBER_REMOVE = 'admin/entitygroup/member/remove';

export async function getDetail(id: string): Promise<object> {
    // params
    if (!validSvc.isText(id)) {
        throw new Error('groupsRepo.getDetail, id is required');
    }

    return apiSvc.getEntity(GET_DETAIL, {
        Entity: {
            Params: {
                Id: id,
            },
        },
    });
}

export async function upsert(action: string, m: object): Promise<HttpUpsert200 | HttpErrorUpsert> {
    switch (action) {
        case 'CREATE':
            return apiSvc.postModel(CREATE_GROUPS, groupsModelAPI(m));
        case 'UPDATE':
            return apiSvc.postModel(UPDATE_GROUP, groupsModelAPI(m));
        default:
            throw new Error('adminGroupsRepo.postGroups, unknown: ' + action);
    }
}

function groupsModelAPI(model): object {
    return {
        Entity: {
            Id: model.Id,
            Name: model.Name.val,
            Type: model.Type.val,
            ObjectState: model.ObjectState.val,
            ContractFulfillment: model.ContractFulfillment.val,
            ContractType: model.ContractType.val,
            Threshold: model.Threshold.val,
        },
    };
}

export async function updateStatus(id: string, action: string): Promise<HttpUpsert200 | HttpErrorUpsert> {
    // params
    if (!validSvc.isText(id)) {
        throw new Error('groupsRepo.updateStatus, id required');
    }
    console.log('groupsRepo update status: ' + action + ' ' + id);

    const request = {
        Params: {
            Id: id,
        },
    };

    switch (action) {
        case 'ACTIVE':
            return apiSvc.postModel(UPDATE_GROUP_STATUS_ACTIVE, request, false, false);
        case 'INACTIVE':
            return apiSvc.postModel(UPDATE_GROUP_STATUS_INACTIVE, request, false, false);
        default:
            throw new Error('adminGroupsRepo.updateStatus, unknown: ' + action);
    }
}

export async function getExcel(fileName: string): Promise<HttpErrorIgnore | undefined> {
    // params
    if (!validSvc.isText(fileName)) {
        throw new Error('groupsRepo.getExcel, filename is required');
    }
    return apiSvc.postGetBinary(GET_EXCEL, {}, fileName, BinaryFileType.Excel);
}

export async function memberEdit(
    action: string,
    groupId: string,
    memId: string,
): Promise<HttpUpsert200 | HttpErrorUpsert> {
    // params
    if (!validSvc.isText(groupId) || !validSvc.isText(memId)) {
        throw new Error('groupRepo.memberEdit, groupId and member id required');
    }

    const editModel = {
        Entity: {
            Params: {
                Id: groupId,
                MemberId: memId,
            },
        },
    };

    switch (action) {
        case 'ADD':
            return apiSvc.postModel(MEMBER_ADD, editModel);
        case 'REMOVE':
            return apiSvc.postModel(MEMBER_REMOVE, editModel);
        default:
            throw new Error('groupsRepo.memberEdit, unknown edit action: ' + action);
    }
}

export const groupsRepo = {
    getDetail,
    upsert,
    updateStatus,
    getExcel,
    memberEdit,
};
export default groupsRepo;
